
var $ = jQuery.noConflict();
$(document).ready(function() {

  $("form").submit(function () {
    if (typeof fbq === "function") {
      console.log('fbq tracked  native');
      fbq('track', 'CompleteRegistration');
    }
  });       

  var existFormSubmitted = setInterval(function() {
    if ( $('.hbspt-form .submitted-message').length > 0 ) {
      
      if (typeof fbq === "function") {
        fbq('track', 'CompleteRegistration');
      }

      clearInterval(existFormSubmitted);
    }
  }, 1);

  
    
    if( $('body').hasClass('blog') ){
        var param = (new URL(location.href)).searchParams.get('page');

        if(param){
          if($('.page-width .resent_post').length){
            $('html,body').animate({
              scrollTop: $('.page-width .resent_post').offset().top - 130
          }, 500);
          }
            
        }
    }

    $( "body.template-warranty.page .rte h2" ).first().addClass( "expand" );

    $('body.template-warranty.page .rte h2').on('click', function(e){
        e.preventDefault();

        if( $(this).hasClass('expand') ){
            $(this).removeClass('expand');
        } else {
            $(this).addClass('expand');
        }
    });

    

    $('.template-case-study .laod_more_case_study').on('click', function(e){
        e.preventDefault();

        var show_count_d = 0;
        var show_count_m = 0;
        $('.blog-articles  .blog-articles__article').each(function(){
          
          if( $(this).hasClass('hide_destop')){ 
            show_count_d = show_count_d + 1;
            if(show_count_d <= 6){
              $(this).removeClass('hide_destop');
              $(this).addClass('show_destop');
            }
          }

          if( $(this).hasClass('hide_mobile')){ 
            show_count_m = show_count_m + 1;
            if(show_count_m <= 3){
              $(this).removeClass('hide_mobile');
              $(this).addClass('show_mobile');
            }
          }
          
        });

        var has_more_d = true;
        var has_more_m = true;
        $('.blog-articles  .blog-articles__article').each(function(){
          if( $(this).hasClass('hide_destop')){ 
            has_more_d = false
          }

          if( $(this).hasClass('hide_mobile')){ 
            has_more_m = false
          }
        });

        if(has_more_d){
          $(this).addClass('hide_desktop');
        }

        if(has_more_m){
          $(this).addClass('hide_mobile');
        }

        // $(this).hide();
    });


    if( $('body').hasClass('template-neovolt-on-grid-system') ){

      var existCondition = setInterval(function() {

        if ( $('.template-neovolt-on-grid-system .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').length > 0 ) {

          $('.template-neovolt-on-grid-system .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').attr('value','Get Connected');          
    
            clearInterval(existCondition);
    
        }
      }, 500);

    }

    if( $('body').hasClass('template-diy-off-grid-system') ){

      var existCondition = setInterval(function() {

        if ( $('.template-diy-off-grid-system .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').length > 0 ) {

          $('.template-diy-off-grid-system .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').attr('value','Get Connected');          
    
            clearInterval(existCondition);
    
        }
      }, 500);

    }

    if( $('body').hasClass('template-off-grid-system') ){

      var existCondition = setInterval(function() {

        if ( $('.template-off-grid-system .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').length > 0 ) {

          $('.template-off-grid-system .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').attr('value','Get Connected');          
    
            clearInterval(existCondition);
    
        }
      }, 500);

    }

    if( $('body').hasClass('template-olipower-deye-voltx') ){

      var existCondition = setInterval(function() {

        if ( $('.template-olipower-deye-voltx .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').length > 0 ) {

          $('.template-olipower-deye-voltx .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').attr('value','Get Connected');          
    
            clearInterval(existCondition);
    
        }
      }, 500);

    }

    if( $('body').hasClass('template-commercial-3') ){

      var existCondition = setInterval(function() {

        if ( $('.template-commercial-3 .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').length > 0 ) {

          $('.template-commercial-3 .getintouch_form .getintouch__form--content .content--container__right .hs_submit.hs-submit .actions input').attr('value','Get Connected');          
    
            clearInterval(existCondition);
    
        }
      }, 500);

      $('.banner .banner__box .banner__buttons a.button').on('click', function(){
        $('html,body').animate({
          scrollTop: $('.get_a_quote_commercial').offset().top - 170
        }, 500);
      });

    }

    if( $('body').hasClass('template-battery-storage-guide') ){
    
      $('.banner.ultimate_guide_banner  .banner__buttons a.button ').on('click', function(e){
        e.preventDefault();
        
        $('html,body').animate({
          scrollTop: $('.getintouch__form--content .content--container__right').offset().top - 170
        }, 500);
        
      });

      

      var existCondition = setInterval(function() {

        if ( $('.hbspt-form .submitted-message').length > 0 ) {
          $('.template-battery-storage-guide .multicolumn_icon').hide();
          $('.template-battery-storage-guide .banner.ultimate_guide_banner').hide();
          $('.template-battery-storage-guide .getintouch_form').hide();
          
          $('.template-battery-storage-guide .banner.ultimate_guide_banner_download').show();

          $("div").scrollTop()

          $('html, body').animate({ scrollTop: 0 }, 'slow');
    
          $('.template-battery-storage-guide .banner.ultimate_guide_banner_download .banner__buttons a.button').attr("href", "https://cdn.shopify.com/s/files/1/0600/6875/7665/files/VoltX_Energy_-_The_Ultimate_Guide_to_Battery_Storage_Systems.pdf?v=1683258324");
          $('.template-battery-storage-guide .banner.ultimate_guide_banner_download .banner__buttons a.button').attr('target','_blank');
          
          clearInterval(existCondition);
        }
      }, 1);
    
    };

    if( $('body').hasClass('template-energy-savings-guide') ){
    
      $('.banner.ultimate_guide_banner  .banner__buttons a.button ').on('click', function(e){
        e.preventDefault();
        
        $('html,body').animate({
          scrollTop: $('.getintouch__form--content .content--container__right').offset().top - 170
        }, 500);
        
      });

      

      var existCondition = setInterval(function() {

        if ( $('.hbspt-form .submitted-message').length > 0 ) {
          $('.template-energy-savings-guide .multicolumn_icon').hide();
          $('.template-energy-savings-guide .banner.ultimate_guide_banner').hide();
          $('.template-energy-savings-guide .getintouch_form').hide();
          
          $('.template-energy-savings-guide .banner.ultimate_guide_banner_download').show();

          $("div").scrollTop()

          $('html, body').animate({ scrollTop: 0 }, 'slow');
    
          $('.template-energy-savings-guide .banner.ultimate_guide_banner_download .banner__buttons a.button').attr("href", "https://cdn.shopify.com/s/files/1/0600/6875/7665/files/Smart-Home-Energy-Savings-Guide.pdf?v=1748565582");
          $('.template-energy-savings-guide .banner.ultimate_guide_banner_download .banner__buttons a.button').attr('target','_blank');
          
          clearInterval(existCondition);
        }
      }, 1);
    
    };
    

});

jQuery(function($){
  
    $.fn.hscrollarrows = function(){
      return this.each(function() {

        
        var navNext = $('<a class="nav-next hide"></a>');
        var navPrev = $('<a class="nav-prev hide"></a>');
        var scrollTime = null;
        var resizeTime = null;
        var scrolling = false;
        
        var elm_w = 0;
        var elem_data_w = 0; 
        var max_scroll = 0;
        var inc_scroll = 0;
        
        calcData = function(){
          elm_w = elem.width();
          elem_data_w = elem_data.width(); 
          max_scroll = elem_data_w - elm_w;
          inc_scroll = elm_w * 0.3; // 20%
        }
        
        revalidate = function(){
          calcData();
          stateNavs();
        }
        
        run = function(){
          calcData();
          setupNavs();
        }
        
        setupNavs = function(){
          
          elem.parent().prepend( navNext );
          elem.parent().prepend( navPrev );
          navNext.on('click', next);
          navPrev.on('click', prev);
          stateNavs();
          
          $(elem).scroll(function() {
              if( !scrolling ){
                clearTimeout( scrollTime );
                scrollTime = setTimeout(function() {
                    stateNavs();
                  }, 250);
              }
          });
          
          $(window).resize(function(){
            clearTimeout( resizeTime );
            resizeTime = setTimeout(function() {
              revalidate();
            }, 250);
          });
        }
        
        stateNavs = function(){
          var current_scroll = elem.scrollLeft();
          if( current_scroll < max_scroll ){
            navNext.removeClass('hide');
          }else{
            navNext.addClass('hide');
          }
          if( current_scroll > 0 ){
            navPrev.removeClass('hide');
          }else{
            navPrev.addClass('hide');
          }
          scrolling = false;
        }
        
        next = function(){
          var current_scroll = elem.scrollLeft();
          if( current_scroll < max_scroll ){
            scrolling = true;
            elem.stop().animate({
              scrollLeft: ( current_scroll + inc_scroll )
            }, stateNavs);
          }
        }
        
        prev = function(){
          var current_scroll = elem.scrollLeft();
          if( current_scroll > 0 ){
            scrolling = true;
            elem.stop().animate({
              scrollLeft: ( current_scroll - inc_scroll )
            }, stateNavs);
          }
        }
        
        var elem = $( this );
        var elem_data = $(':first-child', elem);
        
        run();
        
      });
    }




    $(document).ready(function(){
        $('.blog .blog_filter--container').hscrollarrows();
    });


    // var existChat = setInterval(function() {

    //   if ( $('#hubspot-conversations-iframe').length > 0 ) {

    //     const iframe = document.getElementById("hubspot-conversations-iframe");
 
    //     if (iframe) {
    //       const img = document.createElement("img");
    //       img.src = "https://d1hcq2qixeq4j1.cloudfront.net/cx/2025/06/02/1748827652-eddie_image_4_chat.png";
    //       // img.class = "chat_eddie";
    //       // img.style.position = "absolute"; // use fixed or absolute based on your layout
    //       // img.style.zIndex = "9999";
    //       // img.style.pointerEvents = "none"; // allow clicks to pass through
    //       // img.style.width = "60px"; // adjust as needed
    //       // img.style.bottom = "74px";
    //       // img.style.right = "16px";
    
    //       document.getElementById("hubspot-messages-iframe-container").appendChild(img);

    //       $("#hubspot-messages-iframe-container").children().wrapAll('<div class="inner_wrapper_chat_widget"></div>');


    //       console.log(iframe.getBoundingClientRect().bottom);
    
    //       // Optional: keep image aligned on resize or scroll
    //       const updatePosition = () => {
    //         const rect = iframe.getBoundingClientRect();
    //         // img.style.right = "0px";
    //         // img.style.bottom = "0px";
    //       };
    
    //       window.addEventListener("onLoad", updatePosition);
    //       window.addEventListener("resize", updatePosition);
    //     }
        
    //     clearInterval(existChat);
  
    //   }
    // }, 500);
});